import Dropdown from 'core/dropdown';
import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';

export const StyledCoreDropdown = styled(Dropdown)`
  &&&& {
    display: flex;
    flex: 1 1 auto;
    [data-role='queryBuilder'][data-view-mode='true'] {
      display: none !important;
    }
  }
`;

export const StyledTopTooltip = styled(Tooltip)`
  width: 100%;
  > span {
    width: 100%;
  }
`;
